@if (content()) {
  <div class="accordion-container mr-xlarge-b">
    @if (content().teaserTitle) {
      <h2>{{ content().teaserTitle }}</h2>
    }

    @for (item of content().items; track item; let index = $index, last = $last) {
      <fin-expand
        class="block"
        [class.border-bottom]="last"
        [key]="'cms-accordion-' + content().contentId"
        [id]="'cms-accordion-' + content().contentId + '-' + index"
        #expand
      >
        <div class="trigger pr-small-y flex flex--center border-top">
          <div class="flex-1 medium-type">
            <fcom-heading-tag
              [level]="item.headerLevel ?? DEFAULT_HEADER_LEVEL"
              extraClasses="font-title-small nordic-blue-900-text text-icon-primary"
              >{{ item.teaserTitle }}</fcom-heading-tag
            >
          </div>
          <fcom-icon
            class="flex-1 flex--nogrow rotate icon-medium"
            [class.rotate-active]="expand.isOpen$ | async"
            [name]="SvgLibraryIcon.CHEVRON_DOWN"
          />
        </div>
        <div class="content">
          <fin-cms-json-content [template$]="{ main: [item] } | finToObservable" />
        </div>
      </fin-expand>
    }
  </div>

  <div class="rich-text-container">
    @if (content().teaserTitle) {
      <h2>{{ content().teaserTitle }}</h2>
    }
    @for (item of content().items; track item) {
      <div class="content">
        <fcom-heading-tag
          [level]="item.headerLevel ?? DEFAULT_HEADER_LEVEL"
          extraClasses="font-title-small nordic-blue-900-text text-icon-primary"
          >{{ item.teaserTitle }}</fcom-heading-tag
        >
        <fin-cms-json-content [template$]="{ main: [item] } | finToObservable" />
      </div>
    }
  </div>
}
